import React from 'react';
import PropTypes from 'prop-types';
import { styled } from '@mui/system';
import Box from '@mui/material/Box';
import { CHILDREN_PROP_TYPES } from 'propTypes';
import muiPropForwarding from 'styles/helpers/muiPropForwarding';
import {
  getHeaderLinkLightColor,
  getHeaderLinkHoverColor
} from 'styles/helpers/getThemeStyles';

const DesignAndCustomizationStyledBox = styled(Box, {
  shouldForwardProp: muiPropForwarding(
    'isHiddenOnMobile',
    'shouldDisableFulfillmentOptions'
  )
})(({ theme, isHiddenOnMobile, shouldDisableFulfillmentOptions }) => {
  return {
    '&.MuiBox-root': {
      padding: '0 8px 0 8px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      '& .MuiSvgIcon-root': {
        fill: theme.palette.text.disabled
      },
      '&:hover': {
        cursor: 'pointer',
        '& *': !shouldDisableFulfillmentOptions
          ? {
              fill: getHeaderLinkHoverColor(theme),
              color: getHeaderLinkHoverColor(theme)
            }
          : {}
      },
      [theme.breakpoints.down('md')]: {
        padding: '0 0 0 8px',
        display: `${isHiddenOnMobile ? 'none' : 'flex'}`,
        justifyContent: 'flex-end',
        '& .MuiSvgIcon-root': {
          fill: getHeaderLinkLightColor(theme),
          display: 'flex',
          alignItems: 'center'
        }
      }
    }
  };
});

function AppBarLinkWrapper({ children, onClick, dataTestId, id, ...rest }) {
  const { isHiddenOnMobile, shouldDisableFulfillmentOptions } = rest;
  return (
    <DesignAndCustomizationStyledBox
      id={id}
      data-testid={dataTestId}
      onClick={onClick}
      isHiddenOnMobile={isHiddenOnMobile}
      shouldDisableFulfillmentOptions={shouldDisableFulfillmentOptions}
    >
      {children}
    </DesignAndCustomizationStyledBox>
  );
}

AppBarLinkWrapper.propTypes = {
  id: PropTypes.string,
  children: CHILDREN_PROP_TYPES.isRequired,
  dataTestId: PropTypes.string,
  isHiddenOnMobile: PropTypes.bool,
  onClick: PropTypes.func,
  shouldDisableFulfillmentOptions: PropTypes.bool.isRequired
};

AppBarLinkWrapper.defaultProps = {
  dataTestId: '',
  isHidden: false,
  onClick: () => {}
};

export default AppBarLinkWrapper;
